module.exports = __webpack_public_path__ + "static/media/-_Document management.842719b3.png";